import { useRef, useState, type Dispatch, type SetStateAction } from "react";

type Milliseconds = number;

export function useDebouncedState<T>(init: T | (() => T), time: Milliseconds): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState(init);
  const timeoutHandle = useRef<number>(undefined);
  const setStateDebounced = (input: SetStateAction<T>) => {
    clearTimeout(timeoutHandle.current);
    timeoutHandle.current = setTimeout(() => setState(input), time);
  };
  return [state, setStateDebounced];
}
